import {albumActionTypes} from '../actions/album-action-types';
import { convertSortToParts, albumListRequested} from "../actions/album-actions";

import {
    getMapFromIdObjectArray,
    addIdObjectToNewMap,
    setIdObjectSelectionInNewMap,
    removeObjectFromNewMap,
    addIdObjectToNewMapAlbums,
    addOptionsIfNew,
    addOptionIfNew,
    removeObjectFromArray
} from '../../common/reducer-helpers.js';
import {assetContainerTypes} from "../../assetContainer/actions/asset-container-action-types";
import { store } from "../../App"
import {infoPanelActionTypes} from "../../infoPanel/actions/infoPanel-action-types";

const initialAlbumListState = {
    albums: [],
    offset: 0,
    max: 0,
    count: 0,
    isComplete: false,
    amIfetching: false,
    scrollPosition: 0,
    orderBy: (typeof(localStorage) !== "undefined" && localStorage.getItem("defaultSort")) || "custom",
    arrangeMode: false
};

function sort(albums, orderBy){
    albums.sort((left,right) => {
        if("alpha(asc)" == orderBy) {
            return left.title.localeCompare(right.title)
        }else if("alpha(desc)" == orderBy){
            return right.title.localeCompare(left.title)
        }else if("date(asc)" == orderBy){
            return left.createDate.localeCompare(right.createDate)
        }else if("date(desc)" == orderBy){
            return right.createDate.localeCompare(left.createDate)
        }else{
            return left.displayOrder - right.displayOrder;
        }
    })
}

export const albumList = (state = initialAlbumListState, action) => {
    switch (action.type) {
        case albumActionTypes.SELECT_ALL_ALBUMS: {
            let albums = state.albums.slice();
            for(let i=0;i<albums.length;i++){
                albums[i].selected = true
            }
            return {...state, albums: albums}
        }
        case albumActionTypes.ALBUM_TOGGLE_ARRANGE_MODE: {
            return {...state, arrangeMode: action.flag}
        }
        case albumActionTypes.ALBUM_SORT: {
            if(typeof(localStorage) !== "undefined") {
                localStorage.setItem("defaultSort", action.orderBy);
            }
            if (state.isComplete) {
                let sortedAlbums = state.albums.slice();
                sort(sortedAlbums, action.orderBy);
                return {...state, orderBy: action.orderBy, albums: sortedAlbums}
            }else{
                let sortParts = convertSortToParts(action.orderBy);

                setTimeout(() => albumListRequested(store.dispatch,0,true,50,false,false,sortParts.sortCol,sortParts.sortDir));
                return {...state,orderBy: action.orderBy,offset: 0,max:0,count:0,isComplete:false,albums: []}
            }
        }
        case albumActionTypes.ALBUM_SCROLL:
            return {...state, scrollPosition: action.scrollPosition}
        case albumActionTypes.ALBUM_LIST_REQUEST:
            return {
                ...state,
                amIfetching: true
            };

        case albumActionTypes.ALBUM_LIST_RECEIVED: {
            let isComplete = false;
            if (action.albums.length === 0) {
                isComplete = true;
            }
            else {
                isComplete = action.count <= action.albums.length;
            }
            let albumArray = [];
            if (state.albums.length !== action.count) {
                albumArray = new Array(action.count);
                for (let i = 0; i < action.count; i++) {
                    albumArray[i] = {
                        isLoaded: false,
                        displayOrder: i
                    }
                    if(typeof(action.ids) !== "undefined" && action.ids.length === action.count){
                        albumArray[i].id = action.ids[i];
                    }
                }
            } else {
                albumArray = state.albums.slice(0);
            }
            for (let i = 0; i < action.albums.length; i++) {
                let wasSelected = albumArray[i + action.offsetStart].selected === true;
                albumArray[i + action.offsetStart] = action.albums[i];
                albumArray[i + action.offsetStart].isLoaded = true;
                albumArray[i + action.offsetStart].selected = wasSelected;
            }
            return {
                ...state,
                albums: albumArray,
                offset: action.offset,
                max: action.max,
                count: action.count,
                isComplete: action.isComplete,
                amIfetching: false,
            };
        }

        // case albumActionTypes.ALBUM_SELECTION_LIST_RECEIVED: {
        //     alert ("NOT USED 2")
        //     return {
        //         ...state,
        //         selectionAlbums: addOptionsIfNew(state.selectionAlbums, action.albums, false)
        //     };
        // }
        // case albumActionTypes.ALBUM_RECEIVED:
        //     alert("NOT used")
        //     return {
        //         ...state,
        //         albums: addIdObjectToNewMapAlbums(state, action.album)
        //     };
        case albumActionTypes.ALBUM_LIST_FAILED:
            return {
                ...state,
                amIfetching: false,
                isComplete: true
            };
        case albumActionTypes.ALBUM_SELECTED: {
            let albumArray = state.albums.slice(0);
            for (let i = 0; i < albumArray.length; i++) {
                if (albumArray[i].id === action.albumId) {
                    albumArray[i].selected = true
                }
            }

            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_DESELECTED: {
            let albumArray = state.albums.slice(0);
            for (let i = 0; i < albumArray.length; i++) {
                if (albumArray[i].id === action.albumId) {
                    albumArray[i].selected = false
                }
            }

            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_TOGGLE_SELECTED: {
            let albumArray = state.albums.slice(0);
            for (let i = 0; i < albumArray.length; i++) {
                if (albumArray[i].id === action.albumId) {
                    albumArray[i].selected = (albumArray[i].selected == null ? true : !albumArray[i].selected)
                }
            }

            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_CREATED:{
            let newAlbum = {...action.album,
                lastUpdate: new Date().toISOString(),
                createDate: new Date().toISOString(),
                displayOrder: state.albums.length + 2,
                selected: false,
                isLoaded: true,
                stats: {
                    numPhotos: 0,
                    numClips: 0,
                    numElements: 0,
                    videoDuration: 0
                },
                collectionType: "Photo",
                favoriteYn: "N"};
            let albumArray = state.albums.slice(0)
            albumArray.push(newAlbum)
            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_DELETED:
        {
            let albumArray = state.albums.filter(album => album.id != action.albumId);
            return {
                ...state,
                albums: albumArray,
            };

        }
        case albumActionTypes.CLEAR_ALBUM_SELECTION:{
            let albumArray = state.albums.map(album => {album.selected = false;return album;})
            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_LIST_CLEAR:
            return {
                ...state,
                albums: [],
                offset: 0,
                count: 0,
                max: 0

            };
        case albumActionTypes.ALBUM_UPDATED: {
            let albumArray = state.albums.map(album => album.id === action.albumItem.id ? {...action.albumItem,isLoaded:true,selected:false} : album)
            return {
                ...state,
                albums: albumArray
            };
        }
        case albumActionTypes.ALBUM_ADD_TO_ALBUM_SUCCESS: {
            let albumList = [];
            let found = false;
            for(let i=0;i<state.albums.length;i++){
                if(state.albums[i].id === action.data.targetAlbum.id){
                    albumList.push({...action.data.targetAlbum,isLoaded:true,selected:false});
                    found = true;
                }
                else if(!action.data.deleteOriginal || action.data.sourceAlbumId !== state.albums[i].id){
                    albumList.push({...state.albums[i]})
                }
            }
            if(!found){
                albumList.push(action.data.targetAlbum);
            }
            return {
                ...state,
                albums: albumList
            }
        }
        case albumActionTypes.ALBUMS_ADD_TO_ALBUM_SUCCESS: {
            let albumList = [];
            let found = false
            for(let i=0;i<state.albums.length;i++){
                if(state.albums[i].id === action.data.targetAlbum.id){
                    found = true
                    albumList.push({...action.data.targetAlbum,isLoaded:true,selected:false});
                }else if(!action.data.deleteOriginal || !action.data.sourceAlbumIds.contains(state.albums[i].id)){
                    albumList.push({...state.albums[i]})
                }
            }
            if(!found){
                albumList.push(action.data.targetAlbum);
            }
            return {
                ...state,
                albums: albumList
            }
        }
        case assetContainerTypes.ASSET_CONTAINER_MOVE_ALBUM_ASSET_AFTER:{
            if(action.element.assetId === action.element.moveAfterAssetId){
                return state;
            }
            let assetCollection=state.albums.slice();


            let moveItemIndex = -1;
            let moveToItemIndex = -1;
            //moveAfterItemId
            for(let i=0;i<assetCollection.length;i++){
                if(assetCollection[i].id === action.element.assetId){
                    moveItemIndex=i;
                }else if(assetCollection[i].id === action.element.moveAfterAssetId){
                    moveToItemIndex = i;
                }
                if(moveItemIndex !== -1 && moveToItemIndex !== -1){
                    break;
                }
            }
            let originalSortOrder = assetCollection[moveToItemIndex].displayOrder;
            assetCollection[moveItemIndex].displayOrder = originalSortOrder;
            assetCollection[moveItemIndex].modified=true;
            if(moveItemIndex < moveToItemIndex){
                //i.e. #3 => #5
                for(let i=moveItemIndex+1;i<=moveToItemIndex;i++){
                    assetCollection[i].displayOrder = assetCollection[i].displayOrder - 1;
                    assetCollection[i].modified = true;
                }
            }else{
                for(let i=moveItemIndex-1;i>=moveToItemIndex;i--){
                    assetCollection[i].displayOrder = assetCollection[i].displayOrder + 1;
                    assetCollection[i].modified = true;
                }
            }

            assetCollection = assetCollection.sort((a,b) =>  (a.displayOrder-b.displayOrder));
            return {...state, albums: assetCollection};
        }
        case assetContainerTypes.ASSET_CONTAINER_CANCEL_RESORT_ALBUM: {
            return {
                ...state,

                albums: action.originalValues
            };
        }
        default:
            return state;
    }
};

// const updateAlbumImmutable = (id, map, updateData) => {
//     const newMap = new Map(map);
//     const newItem = {...map.get(id), ...updateData};
//     newMap.set(id, newItem);
//     return newMap;
// };



// WEBPACK FOOTER //
// ./src/album-view/reducers/album-reducer.js